import { useShipperCargoListPageProps } from "./fetch";
import { ShipperCargoListPageUi } from "./ui";

export const ShipperCargoListPage = () => {
  const props = useShipperCargoListPageProps();
  return <ShipperCargoListPageUi {...props} />;
};
